import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import InputBase from '@mui/material/InputBase';
import { Link as RouterLink } from "react-router-dom";
import { useCheckRole } from "../../hooks";
import { startLogout } from "../../store/auth";

import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';

import logoTicoTicket from "../../assets/images/logoticoticket.png";
import { Button, Typography, useScrollTrigger, useMediaQuery, useTheme } from '@mui/material';


const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));




export const PublicMenu = () => {

  const dispatch = useDispatch();

  const name = Cookies.get("name");
  const token = Cookies.get("token");
  const status = Cookies.get("status");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Detectar si es mobile

  const {
    hasRole: hasPlannerRole,
    isCheckingRole: isCheckingPlannerRole,
  } = useCheckRole("PLANNER_ROLE");


  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);


  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };


  const handleMenuClose = () => {
    setAnchorEl(null);

  };

  const handleLogout = () => {
    dispatch(startLogout());
    handleMenuClose();
  };

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,

  });

  let settings = [];
  if (token && status === "authenticated") {
    settings.push({ label: "Mi Cuenta", path: "/account" });
    settings.push({ label: "Mis Tickets", path: "/account/tickets" });
    if (hasPlannerRole && isMobile) { // Mostrar "Panel Admin" solo en mobile
      settings.push({ label: "Panel Admin", path: "/planner" });
    }
    settings.push({ label: "Cerrar Sesión", path: "/", onClick: handleLogout });
  } else {
    settings.push({ label: "Iniciar Sesión", path: "/auth/login" });
    settings.push({ label: "Registrarse", path: "/auth/register" });
  }





  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {settings.map((setting) => (
        <MenuItem
          key={setting.label}
          onClick={() => {
            handleMenuClose();
            setting.onClick && setting.onClick();
          }}
          component={RouterLink}
          to={setting.path}
        >
          <Typography>{setting.label}</Typography>
        </MenuItem>
      ))}
    </Menu>
  );


  return (

    <AppBar elevation={trigger ? 4 : 0}
      sx={{
        py: 1,
        backgroundColor: trigger ? "background.paper" : "transparent",
        transition: "0.3s",
      }}>
      <Toolbar>

        <Box
          component={RouterLink}
          to={`/`}
          sx={{
            display: "flex",
            alignItems: "center",
            marginRight: "auto",
            textDecoration: "none",
          }}
        >
          <img
            src={logoTicoTicket}
            alt="TicoTicket Logo"
            style={{
              height: "30px",
              width: "100%",
            }}
          />
        </Box>
        {/*        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search…"
            inputProps={{ 'aria-label': 'search' }}
          />
        </Search> */}
        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>

          <IconButton
            size="large"
            edge="end"
            aria-label="menu"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
        </Box>


        {/* Mostrar botones si no ha iniciado sesión (pantallas grandes) */}
        {!token || status !== "authenticated" ? (
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
            <Button
              color="inherit"
              component={RouterLink}
              to="auth/login"
              sx={{
                border: 'solid',
                color: 'primary.main'
              }}
            >
              Iniciar Sesión
            </Button>
            <Button
              component={RouterLink}
              to="auth/register"
              sx={{
                bgcolor: 'primary.main',
                color: 'secondary.main',
                '&:hover': {
                  bgcolor: 'primary.dark',
                }
              }}
            >
              Registrarse
            </Button>
          </Box>
        ) : (
          <>
            {/* Mostrar nombre del usuario autenticado en pantallas grandes */}
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              {hasPlannerRole && (
                <Button
                  component={RouterLink}
                  to="/planner"
                  sx={{
                 
                    padding: "0px 30px",
                    mr: 2,
                    bgcolor: 'primary.dark',
                    color: 'secondary.main',
                    textTransform: 'none',
                    '&:hover': {
                      bgcolor: 'primary.light',
                    }
                  }}
                >
                  Panel Admin
                </Button>
              )}
              <Button
                sx={{
                  display: "flex",
                  width: "217px",
                  height: "56px",
                  padding: "0px 10px",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "5px",
                  background: "#221835",
                  boxShadow: "0px 5px 5px 0px rgba(0, 0, 0, 0.30)",
                  color: "#FFF",
                  textTransform: "none",
                  '&:hover': {
                      bgcolor: 'secondary.light',
                    }
                }}
                onClick={handleProfileMenuOpen}
              >
                Hola, {name}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "30px",
                    height: "30px",
                    borderRadius: "100px",
                    background: "#3DDC97",
                    color: "#FFF",
                    fontWeight: "bold",
                  }}
                >
                  {name?.charAt(0).toUpperCase()}
                </Box>
              </Button>
            </Box>
          </>
        )}

      </Toolbar>

      {renderMenu}
    </AppBar>


  );
}
